import { createAction, props } from '@ngrx/store';
import { State } from '@app/core/services/router/store/route-redirect.state';
import { Params } from '@angular/router';

export const saveCallingRoute = createAction(
  '[Route-Redirect] Save Calling Route',
  props<{ url: string; queryParams: Params }>()
);

export const clearCallingRoute = createAction(
  '[Route-Redirect] Clear Calling Route'
);
